import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api, getToken, setToken, clearToken, setActiveTokenKey } from "@/api";

const AuthCtx = createContext(null);

// tokenKey: "superadmin" | `admin:${slug}` — each role/store keeps its own session in localStorage
// allowSuper: izinkan akun superadmin memakai area admin toko (khusus Toko Utama yang tidak punya admin terpisah)
export function AuthProvider({ tokenKey, expectRole, slug, allowSuper, children }) {
  useMemo(() => setActiveTokenKey(tokenKey), [tokenKey]);
  const [user, setUser] = useState(null);

  useEffect(() => {
    setActiveTokenKey(tokenKey);
    setUser(null);
    if (!getToken(tokenKey)) { setUser(false); return; }
    api.get("/auth/me")
      .then((r) => {
        const u = r.data;
        const ok = expectRole === "superadmin" ? u.role === "superadmin" : (u.role === "admin" || (allowSuper && u.role === "superadmin"));
        if (ok) setUser(u); else { clearToken(tokenKey); setUser(false); }
      })
      .catch(() => { clearToken(tokenKey); setUser(false); });
  }, [tokenKey, expectRole, allowSuper]);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password, expect_role: expectRole, slug });
    setToken(tokenKey, data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => { clearToken(tokenKey); setUser(false); };

  return <AuthCtx.Provider value={{ user, login, logout, tokenKey }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
